import { j as t } from "./kezios-design-system.esm172.js";
import { Stack as s, Text as l } from "@mantine/core";
import { Spacing as i } from "./kezios-design-system.esm135.js";
const g = ({
  category: r,
  title: n,
  subtitle: c,
  variant: e = "center",
  titleComponent: x,
  subtitleComponent: o
}) => /* @__PURE__ */ t.jsx(
  s,
  {
    align: e === "left" ? "flex-start" : "center",
    justify: "center",
    w: "100%",
    children: /* @__PURE__ */ t.jsxs(s, { w: e === "left" ? 448 : 768, maw: "100%", gap: i.s5, children: [
      /* @__PURE__ */ t.jsxs(s, { w: "100%", gap: i.s3, children: [
        r && /* @__PURE__ */ t.jsx(
          l,
          {
            style: { textAlign: e },
            variant: "textMd.semibold",
            c: "primary.7",
            children: r
          }
        ),
        n && /* @__PURE__ */ t.jsx(
          l,
          {
            style: { textAlign: e },
            variant: `${e === "left" ? "displayLg" : "displayMd"}.semibold`,
            c: "gray.9",
            component: x,
            children: n
          }
        )
      ] }),
      c && /* @__PURE__ */ t.jsx(
        l,
        {
          style: { textAlign: e },
          variant: e === "left" ? "textLg" : "textXl",
          c: "gray.6",
          component: o,
          children: c
        }
      )
    ] })
  }
);
export {
  g as SectionHeader
};
